import {
  ON_REPORTS_SET_CUSTOM_EVENTS,
  ON_REPORTS_SHOW_ALL_EVENTS_CLICKED,
  ON_REPORTS_SELECTED_CURRENCY_CHANGE,
  UPDATE_STATE_WITH_FETCHED_REPORT,
} from '../actions';

const initialState = {
  ids: [],
  events: {}
};

export default (state = initialState, action) => {
  switch (action.type){
    default:
      return state;

    case UPDATE_STATE_WITH_FETCHED_REPORT:{
      return { ...state, ids: action.payload.fetchedReport.events };
    }

    case ON_REPORTS_SET_CUSTOM_EVENTS:{
      return {
        ids: action.payload.ids,
        events: action.payload.events
      };
      break;
    }

    case ON_REPORTS_SHOW_ALL_EVENTS_CLICKED:
    case ON_REPORTS_SELECTED_CURRENCY_CHANGE:{
      return initialState;
      break;
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/selected-events.js